import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { InterceptorUtil, OccEndpointsService, USE_CLIENT_TOKEN } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class RecaptchaV2CheckResponseService {
  private http = inject(HttpClient);
  private occEndpoints = inject(OccEndpointsService);

  checkResponse(response: string): Observable<boolean> {
    const url = this.occEndpoints.buildUrl('recaptchaV2CheckResponse', {
      urlParams: { response },
    });

    let headers = new HttpHeaders();
    headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);

    return this.http.get<boolean>(url, { headers });
  }
}
